var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "30px",
    viewBox: "0 0 16 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Left_Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.6391787,2.61417875 L3.23302375,15.0203338 L15.6391787,27.4264888 C16.1611637,27.9471388 16.1611637,28.7935288 15.6391787,29.3141788 C15.1185287,29.8361638 14.2721387,29.8361638 13.7514887,29.3141788 L0.40148875,15.9641788 C-0.12049625,15.4435288 -0.12049625,14.5971388 0.40148875,14.0764888 L13.7514887,0.72648875 C14.2721387,0.20450375 15.1185287,0.20450375 15.6391787,0.72648875 C16.1611637,1.24713875 16.1611637,2.09352875 15.6391787,2.61417875 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-KnowledgeBase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Left_Icon",
    fill: "#0067DF",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselIconLeft);
export default __webpack_public_path__ + "static/media/Carousel_Icon_Left.a27fa435cf0602f49ea12cb0db8db057.svg";
export { ForwardRef as ReactComponent };